// extracted by mini-css-extract-plugin
module.exports = {"box":"ActivityIndicator_box__1R9iA","beyondBox":"ActivityIndicator_beyondBox__2-Gsh","maskLayer":"ActivityIndicator_maskLayer__tp3po","Spinner":"ActivityIndicator_Spinner__2dzsS"};